import React, { useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import config from "../../Config";
import FeeSystemMenu from "./FeeSystemMenu";

function ChangeScrollDate() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [RegistrationNo, setRegistrationNo] = useState("");
  const [StudentID, setStudentID] = useState("");
  const [ChallanNo, setChallanNo] = useState("");
  const [NewDate, setNewDate] = useState(moment().format("YYYY-MM-DD"));

  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [record, setRecord] = useState(null);

  const getPayload = () => ({
    AccessKey,
    UserID,
    MemberType,
    Registration_No: RegistrationNo.trim(),
    Student_ID: parseInt(StudentID, 10) || 0,
    ChallanNo: ChallanNo.trim(),
  });

  const fetchDetails = async () => {
    if (!ChallanNo.trim()) {
      toast.error("Please enter challan number.");
      return;
    }
    if (!RegistrationNo.trim() && !(parseInt(StudentID, 10) > 0)) {
      toast.error("Please enter registration no or student id.");
      return;
    }

    setLoading(true);
    setRecord(null);
    try {
      const response = await axios.post(
        `${config.base_url}ScrollEntry/GetScrollDateChangeDetails`,
        getPayload(),
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data?.status_code === 1) {
        setRecord(response.data.Record);
      } else {
        toast.error(response.data?.status_message || "No record found.");
      }
    } catch {
      toast.error("Network Error..");
    } finally {
      setLoading(false);
    }
  };

  const updateDate = async () => {
    if (!record) {
      toast.error("Please fetch challan details first.");
      return;
    }
    if (!NewDate) {
      toast.error("Please select new date.");
      return;
    }

    setUpdating(true);
    try {
      const response = await axios.post(
        `${config.base_url}ScrollEntry/UpdateScrollDate`,
        {
          ...getPayload(),
          Dated: NewDate,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data?.status_code === 1) {
        toast.success(response.data?.status_message || "Updated successfully.");
        fetchDetails();
      } else {
        toast.error(response.data?.status_message || "Update failed.");
      }
    } catch {
      toast.error("Network Error..");
    } finally {
      setUpdating(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <FeeSystemMenu />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">Fee System</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Change Scroll Date
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Change Scroll / Deposit Date</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card mb-2">
              <div className="card-body">
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <label>Registration No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={RegistrationNo}
                      onChange={(e) => setRegistrationNo(e.target.value)}
                      placeholder="Optional"
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Student ID</label>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      value={StudentID}
                      onChange={(e) => setStudentID(e.target.value)}
                      placeholder="Optional"
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Challan Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ChallanNo}
                      onChange={(e) => setChallanNo(e.target.value)}
                      placeholder="Required"
                    />
                  </div>
                  <div className="col-md-3">
                    <button className="button button-primary w-100" onClick={fetchDetails} disabled={loading}>
                      {loading ? "Loading..." : "Fetch Details"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {record && (
              <>
                <div className="card mb-2">
                  <div className="card-body">
                    <table className="table table-theme mb-0">
                      <thead>
                        <tr>
                          <th>Student ID</th>
                          <th>Reg No</th>
                          <th>Student Name</th>
                          <th>Father Name</th>
                          <th>Challan No</th>
                          <th>Receipt No</th>
                          <th>Amount Deposited</th>
                          <th>Bank_Scroll_Date</th>
                          <th>ADLedger ReceivedDate</th>
                          <th>ScrollEntry Dated</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{record.Student_ID}</td>
                          <td>{record.Registration_No}</td>
                          <td>{record.Student_Name}</td>
                          <td>{record.Father_Name}</td>
                          <td>{record.Challan_No}</td>
                          <td>{record.Receipt_No || "-"}</td>
                          <td>{record.Amount_Deposited}</td>
                          <td>{record.Bank_Scroll_Date ? moment(record.Bank_Scroll_Date).format(config.date_format) : "-"}</td>
                          <td>{record.Ledger_ReceivedDate ? moment(record.Ledger_ReceivedDate).format(config.date_format) : "-"}</td>
                          <td>{record.Scroll_Dated ? moment(record.Scroll_Dated).format(config.date_format) : "-"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      <div className="col-md-3">
                        <label>New Deposit Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={NewDate}
                          onChange={(e) => setNewDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <button className="button button-primary w-100" onClick={updateDate} disabled={updating}>
                          {updating ? "Updating..." : "Update Date"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {(loading || updating) && (
              <div className="text-center mt-3">
                <Spinner animation="border" role="status"></Spinner>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangeScrollDate;
